import { modalReducer } from '@guryou/html-components';
import { dealReducer } from '@guryou/redux';
import { applyMiddleware, compose, createStore } from 'redux';
// import { createLogger } from 'redux-logger';
import { persistCombineReducers, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';

// PROD
const mdlwprod = applyMiddleware(promise, thunk);

// DEV
// const mdlwdev = applyMiddleware(promise, thunk, createLogger());

const persistConfig = {
  key: 'waas',
  storage,
  whitelist: ['auth', 'providerAuth'],
};

const persistedReducer = persistCombineReducers(persistConfig, { ...dealReducer, modal: modalReducer });
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = mdlwprod;
const store = createStore(persistedReducer, composeEnhancers(middleware));
const persistor = persistStore(store);

export { persistor, store };
